import React, { useEffect, useRef, useState } from "react";
import {
    IconButton,
    Popover,
    Paper,
    Typography,
    Backdrop,
    makeStyles,
    Box
} from "@material-ui/core";
import { shallowEqual, useSelector } from "react-redux";
import { XIcon } from "@phosphor-icons/react";

import { commonSelector } from 'redux/custom-selector';
import VSideBarMenuIcon from '../../icons/VSideBarMenuIcon';


const useStyles = makeStyles((theme) => ({
    highlight: {
        position: "relative",
        zIndex: 1301,
        backgroundColor: theme.palette.background.paper,
        borderRadius: 0,
    },
    tooltip: {
        padding: theme.spacing(1.5),
        maxWidth: 331,
        position: 'relative',
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
    },
    menuIcon: {
        '& svg': {
            color: theme.palette.alert.logoColor,
        }
    },
    iconWrapper: {
        display: 'inline-flex',
    },
    arrow: {
        position: 'absolute',
        width: 18,
        height: 12,
        zIndex: 1,
        top: -12,
        left: 5,
        borderLeft: "8px solid transparent",
        borderRight: "8px solid transparent",
        borderBottom: `8px solid white`,
    },

    closeBtn: {
        '& svg': {
            color: theme.palette.text.primary
        }
    },
    text: {
        fontWeight: 500
    }
}));

export default function SideBarMenuButton({ onToggleSideBar, isOpen }) {
    // ** States
    const [open, setOpen] = useState(false);

    const reduxData = useSelector(commonSelector, shallowEqual);
    const btnRef = useRef(null);
    const classes = useStyles();

    const STORAGE_KEY = `menu_button_tour_seen-${reduxData?.organiserId}`;

    // ** Effects
    useEffect(() => {
        const seen = localStorage.getItem(STORAGE_KEY);
        if (!seen) {
            if (btnRef?.current) {
                setOpen(true);
            }
        }
    }, []);

    // ** Handlers
    const closeTour = () => {
        localStorage.setItem(STORAGE_KEY, true);
        setOpen(false);
    };


    return (
        <>
            <Backdrop
                open={open}
                onClick={closeTour}
                style={{
                    zIndex: 1300,
                    backgroundColor: "rgba(0,0,0,0.5)",
                }}
            />

            <IconButton
                ref={btnRef}
                aria-label="menu"
                className={`${classes.menuIcon} ${open ? classes.highlight : ""}`}
                onClick={() => onToggleSideBar()}
            >
                <Box key={isOpen ? 'open' : 'closed'} component="span" className={classes.iconWrapper}>
                    <VSideBarMenuIcon width='16px' height='16px' />
                </Box>
            </IconButton>

            <Popover
                open={open}
                anchorEl={btnRef.current}
                onClose={closeTour}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                disableRestoreFocus
                PaperProps={{
                    style: {
                        marginTop: 16,
                        overflow: 'visible',
                    },
                }}
            >
                <Box className={classes.arrow} />
                <Paper className={classes.tooltip} elevation={0}>
                    <Typography variant="body1" className={classes.text}>
                        You can toggle the menu from here
                    </Typography>
                    <IconButton
                        size="small"
                        className={classes.closeBtn}
                        onClick={closeTour}
                    >
                        <XIcon width={16} weight="bold" />
                    </IconButton>
                </Paper>
            </Popover>
        </>
    );
}
